module.exports = __webpack_public_path__ + "media/icon_transaction/bird_2-b3907d0f.png";